<template>
  <div class="brandlider-cls mb-5">
    <div class="brand-slider round-arrow" v-if="brands && brands.length > 0">
      <VueSlickCarousel v-bind="settings">
        <div
          v-for="(brand, index) in brands"
          :key="index"
          class="vue-slide-carousel"
        >
          <router-link
            v-if="brand.restaurants.length > 1"
            :to="{
              name: 'brand-items',
              params: { brand_id: base64_encode(brand.id) },
            }"
            class="brand-link"
            @click="settitle(brand.name)"
          >
            <div class="testimonial-brnd">
              <img :src="brand.image" />
              <p>{{ brand.name }}</p>
            </div>
          </router-link>
          <router-link
            v-else-if="brand.restaurants.length === 1"
            :to="{
              name: 'vendor',
              params: { restaurant_name: brand.restaurants_slug[0] },
            }"
            class="brand-link"
          >
            <div class="testimonial-brnd">
              <img :src="brand.image" />
              <p>{{ brand.name }}</p>
            </div>
          </router-link>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  props: ["brands"],
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        focusOnSelect: true,
        touchThreshold: 5,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 8,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 6,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  methods: {
    settitle(value) {
      localStorage.setItem("brandname", value);
    },
  },
};
</script>